import { computed } from '@vue/composition-api';
import { useStorymapStore } from '../useModule';
import { StorymapPrioFrameworkType } from '../../api/queries';
import { CardColor } from '@/api/workspaceSettings/queries';
import { isLastChangeWithinPeriod } from './lastChangeWithinPeriod';

export const subtasksWithoutArchives = computed(() => {
    const state = useStorymapStore().state;

    const archivedReleaseIds = state.releases.filter((x) => x.isArchived).map((x) => x.id);

    return state.subtasks.filter((x) => !archivedReleaseIds.includes(x.releaseId));
});

export const isFiltered = computed(() => {
    const filterState = useStorymapStore().state.filterState;

    return (
        filterState.assigneeUserIds.length > 0 ||
        filterState.statusKeys.length > 0 ||
        filterState.personaIds.length > 0 ||
        filterState.annotationIds.length > 0 ||
        filterState.colors.length > 0 ||
        filterState.prioIds.length > 0 ||
        filterState.businessValues.length > 0 ||
        filterState.efforts.length > 0 ||
        (filterState.updatedDateFrom != null && filterState.updatedDateTo != null) ||
        Object.values(filterState.checkboxStates).some((x) => x)
    );
});

export const filteredSubtasks = computed(() => {
    const state = useStorymapStore().state;
    const filterState = state.filterState;

    return subtasksWithoutArchives.value.filter((card) => {
        if (card.color === CardColor.TransparentAnnotation) {
            return false;
        }

        const filteredByAssignee =
            filterState.assigneeUserIds.length === 0 ||
            filterState.assigneeUserIds.includes(card.assigneeUserId) ||
            (filterState.assigneeUserIds.includes('-1') && card.assigneeUserId == null);

        const filteredByStatus = filterState.statusKeys.length === 0 || filterState.statusKeys.includes(card.status);

        const filteredByPersonas = filterState.personaIds.length === 0 || filterState.personaIds.some((x) => card.personaIds.includes(x));

        const filteredByAnnotations =
            filterState.annotationIds.length === 0 || filterState.annotationIds.some((x) => card.annotationIds.includes(x));

        const filteredByPrio =
            filterState.prioIds.length === 0 ||
            filterState.prioIds.some(
                (x) =>
                    (state.prioFrameworkType == StorymapPrioFrameworkType.Basic && card.basicPrioValue == x) ||
                    (state.prioFrameworkType == StorymapPrioFrameworkType.Kano && card.kanoPrioValue == x) ||
                    (state.prioFrameworkType == StorymapPrioFrameworkType.Moscow && card.moscowPrioValue == x)
            );

        const filteredByBusinessValue =
            filterState.businessValues.length === 0 || filterState.businessValues.some((x) => card.businessValue == x);

        const filteredByEffort = filterState.efforts.length === 0 || filterState.efforts.some((x) => card.effort == x);

        const filteredByColors = filterState.colors.length === 0 || filterState.colors.some((x) => card.color == x);

        const filteredByDates =
            (filterState.updatedDateFrom == null && filterState.updatedDateTo == null) ||
            isLastChangeWithinPeriod(card.createdAt, card.lastUpdatedAt, filterState.updatedDateFrom, filterState.updatedDateTo);

        const filterByCreatedByOthers =
            filterState.checkboxStates.createdByOthers == false || card.createdByUserId != initAppData.currentUser.currentUserShortId;

        const filterByCreatedByMe =
            filterState.checkboxStates.createdByMe == false || card.createdByUserId == initAppData.currentUser.currentUserShortId;

        const filterByLastUpdateByOthers =
            filterState.checkboxStates.lastUpdatedByOthers == false ||
            (card.lastUpdatedByUserId != null && card.lastUpdatedByUserId != initAppData.currentUser.currentUserShortId);

        const filterByLastUpdateByMe =
            filterState.checkboxStates.lastUpdatedByMe == false ||
            (card.lastUpdatedByUserId != null && card.lastUpdatedByUserId == initAppData.currentUser.currentUserShortId);

        const filterByHasDetails = filterState.checkboxStates.hasDetails == false || card.hasDescription;

        const filterByHasNoDetails = filterState.checkboxStates.hasNoDetails == false || !card.hasDescription;

        const filterByHasEstimation = filterState.checkboxStates.hasEstimation == false || card.estimation != null;

        const filterByHasNoEstimation = filterState.checkboxStates.hasNoEstimation == false || card.estimation == null;

        const filterByHasAttachment = filterState.checkboxStates.hasAttachment == false || card.hasAttachment;

        const filterByHasNoAttachment = filterState.checkboxStates.hasNoAttachment == false || !card.hasAttachment;

        const filterByLinkedToIssueTracker = filterState.checkboxStates.isLinkedToIssueTracker == false || card.isLinkedToIntegrationTool;

        const filterByNotLinkedToIssueTracker =
            filterState.checkboxStates.isNotLinkedToIssueTracker == false || !card.isLinkedToIntegrationTool;

        return (
            filteredByAssignee &&
            filteredByStatus &&
            filteredByPersonas &&
            filteredByAnnotations &&
            filteredByColors &&
            filteredByDates &&
            filterByCreatedByOthers &&
            filterByCreatedByMe &&
            filterByLastUpdateByOthers &&
            filterByLastUpdateByMe &&
            filterByHasDetails &&
            filterByHasNoDetails &&
            filterByHasEstimation &&
            filterByHasNoEstimation &&
            filterByHasAttachment &&
            filterByHasNoAttachment &&
            filterByLinkedToIssueTracker &&
            filterByNotLinkedToIssueTracker &&
            filteredByPrio &&
            filteredByBusinessValue &&
            filteredByEffort
        );
    });
});
